import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'showSmartAssistantButton';

@Injectable({ providedIn: 'root' })
export class SmartAssistantPreferenceService {
	private readonly visibleSubject = new BehaviorSubject<boolean>(this.readStoredOrDefault());

	readonly visible$ = this.visibleSubject.asObservable();

	isVisible(): boolean {
		return this.visibleSubject.value;
	}

	setVisible(show: boolean): void {
		localStorage.setItem(STORAGE_KEY, show ? 'true' : 'false');
		this.visibleSubject.next(show);
	}

	private readStoredOrDefault(): boolean {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === 'false') {
			return false;
		}
		return true;
	}
}
